import { render, staticRenderFns } from "./BankAccountForm.vue?vue&type=template&id=0bbd3348&scoped=true"
import script from "./BankAccountForm.vue?vue&type=script&lang=js"
export * from "./BankAccountForm.vue?vue&type=script&lang=js"
import style0 from "./BankAccountForm.vue?vue&type=style&index=0&id=0bbd3348&prod&lang=scss&scoped=true"
import style1 from "./BankAccountForm.vue?vue&type=style&index=1&id=0bbd3348&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbd3348",
  null
  
)

export default component.exports